import { WeChatTriggerLink, WeChatTriggerLinkMap } from "../manager/DefineInterface";

let weChatTriggerTimeLinkMap:WeChatTriggerLinkMap = null;

export default function weChatTriggerTimeLinks(){
    if(!weChatTriggerTimeLinkMap){
        weChatTriggerTimeLinkMap = {
            "0":{//母妃来信
                id:"0",
                isOnly:true, 
                // autoTriggerDay:0,
                link:[
                    {id:"4000",currentDay:0}
                ]
            },
            "1":{//江南好友来信
                id:"1",
                isOnly:true,
                link:[
                    {id:"4001",currentDay:0},
                ]
            },
            "2":{//皇妹来信
                id:"2",
                isOnly:true,
                
                link:[
                    {id:"4002",currentDay:0},

                ]
            },
            "3":{//神秘人来信
                id:"3",
                isOnly:true,
                link:[
                    {id:"4003",currentDay:0},

                ]
            },
            "4":{//皇妹来信
                id:"4",
                isOnly:true,
                link:[
                    {id:"4004",currentDay:1},

                ]
            },
            "5":{//国舅来信
                id:"5",
                isOnly:true,
                link:[
                    {id:"4005",currentDay:1},

                ]
            },
            "6":{//母妃来信
                id:"6",
                isOnly:true,
                
                link:[
                    {id:"4006",currentDay:0},

                ]
            },
            "7":{//神秘人来信
                id:"7",
                isOnly:true,
                link:[
                    {id:"4007",currentDay:0},

                ]
            },
            "8":{//国舅来信
                id:"8",
                isOnly:true,
                
                link:[
                    {id:"4008",currentDay:1},

                ]
            },

            "9":{//当铺老板娘来信
                id:"9",
                isOnly:true,
                
                link:[
                    {id:"5001",currentDay:0},

                ]
            },
            "10":{//百乐门接待官来信
                id:"10",
                isOnly:true,
                
                link:[
                    {id:"5003",currentDay:0},

                ]
            },
            "11":{//工地包工头来信
                id:"11",
                isOnly:true,
                
                link:[
                    {id:"5005",currentDay:0},

                ]
            },
            "12":{//赌石老板来信
                id:"12",
                isOnly:true,
                
                link:[
                    {id:"5007",currentDay:0},

                ]
            },
            "13":{//招募官来信
                id:"13",
                isOnly:true,
                
                link:[
                    {id:"5009",currentDay:0},

                ]
            },
            "14":{//城池
                id:"14",
                isOnly:true,
                
                link:[
                    {id:"5021",currentDay:0},

                ]
            },
            "15":{//当铺老板娘来信2
                id:"15",
                isOnly:true,
                
                link:[
                    {id:"5002",currentDay:1},

                ]
            },
            "16":{//百乐门接待官来信2
                id:"16",
                isOnly:true,
                
                link:[
                    {id:"5004",currentDay:1},

                ]
            },
            "17":{//工地包工头来信2
                id:"17",
                isOnly:true,
                
                link:[
                    {id:"5006",currentDay:1},

                ]
            },
            "18":{//赌石老板来信2
                id:"18",
                isOnly:true,
                
                link:[
                    {id:"5008",currentDay:1},

                ]
            },
            "19":{//招募官来信2
                id:"19",
                isOnly:true,
                
                link:[
                    {id:"5010",currentDay:1},

                ]
            },
            "20":{//曹仁
                id:"20",
                isOnly:true,
                
                link:[
                    {id:"5011",currentDay:0},

                ]
            },
            "21":{//马超
                id:"21",
                isOnly:true,
                
                link:[
                    {id:"5012",currentDay:0},

                ]
            },
            "22":{//黄忠
                id:"22",
                isOnly:true,
                
                link:[
                    {id:"5013",currentDay:0},

                ]
            },
            "23":{//马岱
                id:"23",
                isOnly:true,
                
                link:[
                    {id:"5014",currentDay:0},

                ]
            },
            "24":{//魏延
                id:"24",
                isOnly:true,
                
                link:[
                    {id:"5015",currentDay:0},

                ]
            },
            "25":{//夏侯惇
                id:"25",
                isOnly:true,
                
                link:[
                    {id:"5016",currentDay:0},

                ]
            },
            "26":{//徐晃
                id:"26",
                isOnly:true,
                
                link:[
                    {id:"5017",currentDay:0},

                ]
            },
            "27":{//许褚
                id:"27",
                isOnly:true,
                
                link:[
                    {id:"5018",currentDay:0},

                ]
            },
            "28":{//颜良
                id:"28",
                isOnly:true,
                
                link:[
                    {id:"5019",currentDay:0},

                ]
            },
            "29":{//赵云
                id:"29",
                isOnly:true,
                
                link:[
                    {id:"5020",currentDay:0},

                ]
            },
            "30":{//赵云
                id:"30",
                isOnly:true,
                
                link:[
                    {id:"5022",currentDay:0},

                ]
            },
            "31":{//老妇人的孙女1
                id:"31",
                isOnly:true,
                
                link:[
                    {id:"4009",currentDay:1},

                ]
            },
            "32":{//老妇人的孙女1
                id:"32",
                isOnly:true,
                
                link:[
                    {id:"4010",currentDay:1},

                ]
            },
            "33":{//武林盟主的女儿来信
                id:"33",
                isOnly:true,
                
                link:[
                    {id:"4012",currentDay:1},

                ]
            },
            "34":{//武林盟主被丘比特射了以后
                id:"34",
                isOnly:true,
                
                link:[
                    {id:"5023",currentDay:1},

                ]
            },
            "35":{//答应武林的彩礼3天后
                id:"35",
                isOnly:true,
                
                link:[
                    {id:"5024",currentDay:3},

                ]
            },
            "36":{//答应武林的彩礼4天后
                id:"36",
                isOnly:true,
                
                link:[
                    {id:"5025",currentDay:4},

                ]
            },
            "37":{//答应武林的彩礼5天后
                id:"37",
                isOnly:true,
                
                link:[
                    {id:"5026",currentDay:5},
                ]
            },
            "38":{//答应武林的彩礼6天后
                id:"38",
                isOnly:true,
                
                link:[
                    {id:"5027",currentDay:6},
                ]
            },
            "39":{//答应武林的彩礼7天后
                id:"39",
                isOnly:true,
                
                link:[
                    {id:"5028",currentDay:7},

                ]
            },
            "40":{//交付彩礼后
                id:"40",
                isOnly:true,
                
                link:[
                    {id:"5029",currentDay:1},

                ]
            },
            "41":{//获得九品官圣旨
                id:"41",
                isOnly:true,
                
                link:[
                    {id:"5030",currentDay:1},

                ]
            },
            "42":{//贵妃来信
                id:"42",
                isOnly:true,
                
                link:[
                    {id:"5031",currentDay:0},

                ]
            },
            "43":{//贵妃来信2次来信，第2次奖赏
                id:"43",
                isOnly:true,
                
                link:[
                    {id:"5032",currentDay:0},

                ]
            },
            "44":{//贵妃第3次来信，让玩家去树林深处
                id:"44",
                isOnly:true,
                
                link:[
                    {id:"5034",currentDay:0},

                ]
            },
            "45":{//公公来信，升官8品
                id:"45",
                isOnly:true,
                
                link:[
                    {id:"5033",currentDay:0},

                ]
            },
            "46":{//贵妃第4次来信，让玩家去探押镖车队虚实
                id:"46",
                isOnly:true,
                
                link:[
                    {id:"5035",currentDay:1},

                ]
            },
            "47":{//贵妃第5次来信，自办押镖车队
                id:"47",
                isOnly:true,
                
                link:[
                    {id:"5036",currentDay:1},

                ]
            },
            "48":{//贵妃第6此来信，引荐进贡
                id:"48",
                isOnly:true,
                
                link:[
                    {id:"5037",currentDay:0},

                ]
            },
            "49":{//套牛新玩法
                id:"49",
                isOnly:true,
                
                link:[
                    {id:"5038",currentDay:1},

                ]
            },
            "50":{//套牛新玩法
                id:"50",
                isOnly:true,
                
                link:[
                    {id:"5039",currentDay:1},

                ]
            },
            "51":{//神秘人告知救老婆位置
                id:"51",
                isOnly:true,
                
                link:[
                    {id:"5040",currentDay:0},

                ]
            },
            "52":{//老丈人来信
                id:"52",
                isOnly:true,
                
                link:[
                    {id:"5041",currentDay:1},

                ]
            },
            "53":{//家里没钱了，供不起这些老婆孩子啦
                id:"53",
                isOnly:false,
                
                link:[
                    {id:"5042",currentDay:1},

                ]
            },
            "54":{//点击黑影后触发的神秘人
                id:"54",
                isOnly:true,
                
                link:[
                    {id:"5043",currentDay:0},

                ]
            },
            "55":{//点击黑影后触发的神秘人
                id:"55",
                isOnly:true,
                
                link:[
                    {id:"4013",currentDay:0},

                ]
            },
            "56":{//公公的传令
                id:"56",
                isOnly:true,
                
                link:[
                    {id:"5044",currentDay:0},

                ]
            },
            // "9":{//江南好友来信
            //     id:"9",
            //     isOnly:true,
            //     link:[
            //         {id:"4009",currentDay:1},

            //     ]
            // },
            // "10":{//母妃来信
            //     id:"10",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4010",currentDay:1},

            //     ]
            // },
            // "11":{//神秘人来信
            //     id:"11",
            //     isOnly:true,
            //     link:[
            //         {id:"4011",currentDay:1},

            //     ]
            // },
            // "12":{//国舅来信
            //     id:"12",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4012",currentDay:1},

            //     ]
            // },
            // "13":{//江南好友来信
            //     id:"13",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4013",currentDay:1},

            //     ]
            // },
            // "14":{//差事信件
            //     id:"14",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4014",currentDay:1},
        

            //     ]
            // },
            // "15":{//母妃来信
            //     id:"15",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4015",currentDay:1},

            //     ]
            // },

            // "16":{//幽州巡抚来信
            //     id:"16",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4016",currentDay:1},


            //     ]
            // },
            // "17":{//波斯使团来信
            //     id:"17",
            //     isOnly:true,
            //     link:[
            //         {id:"4017",currentDay:1},


            //     ]
            // },
            // "18":{//江南好友来信
            //     id:"18",
            //     isOnly:true,

            //     link:[
            //         {id:"4018",currentDay:1},

            //     ]
            // },
            // "19":{//幽州巡抚来信
            //     id:"19",
            //     isOnly:true,
            //     link:[
            //         {id:"4019",currentDay:1},


            //     ]
            // },
            // "20":{//母妃来信
            //     id:"20",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4020",currentDay:1},


            //     ]
            // },
            // "21":{//波斯使团来信
            //     id:"21",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4021",currentDay:1},


            //     ]
            // },
            // "22":{//私盐贩子
            //     id:"22",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4022",currentDay:1},


            //     ]
            // },
            // "23":{//江南好友来信
            //     id:"23",
            //     isOnly:true,
            
            //     link:[
            //         {id:"4023",currentDay:1},


            //     ]
            // },
            // "24":{//邻居来信
            //     id:"24",
            //     isOnly:true,
                
            //     link:[
            //         {id:"4024",currentDay:1},


            //     ]
            // },
            // "25":{//幽州巡抚来信
            //     id:"25",
            //     isOnly:true,
            //     link:[
            //         {id:"4025",currentDay:1},


            //     ]
            // },
            // "26":{//老师来信
            //     id:"26",
            //     isOnly:true,
            //     link:[
            //         {id:"4026",currentDay:1},


            //     ]
            // },
            // "27":{//神秘人来信
            //     id:"27",
            //     isOnly:true,
            //     link:[
            //         {id:"4027",currentDay:1},


            //     ]
            // },
            // "28":{//乞丐来信
            //     id:"28",
            //     isOnly:true,
            //     link:[
            //         {id:"4028",currentDay:1},
    
            //     ]
            // },

            
        }
    }
    return weChatTriggerTimeLinkMap;
}

export let startLinkId:string = "0";

export function getOneWeChatTriggerTimeLinkById(id:string | number){
    return weChatTriggerTimeLinks()[id];
}
